import { Dialog, DialogContent, Button, Typography, Box } from '@mui/material';

const FolioDialog = (props) => {
  const { handleClose, open, data } = props;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullScreen
    >
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          pt: 5,
        }}
      >
        <Typography
          align="center"
          color="primary.gold"
          fontWeight={1000}
          sx={{
            fontSize: 30,
          }}
        >
          Registro Exitoso, gracias.
        </Typography>
        <Box
          sx={{
            width: 250,
            height: 250,
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'primary.main',
            my: 2,
            p: 2,
          }}
        >
          <Typography
            align="center"
            color="primary.gold"
            fontWeight={1000}
            sx={{
              fontSize: 50,
            }}
          >
            Truno: {data?.folio || '0000'}
          </Typography>
        </Box>
        <Typography
          align="center"
          color="primary.black"
          fontWeight={1000}
          sx={{
            fontSize: 25,
          }}
        >
          *Favor de guardar su folio, solo se genera una vez y no se puede recuperar.*
        </Typography>
        <Button
          onClick={() => {
            //Recargar pagina actual
            window.location.reload();
          }}
          variant="contained"
          color="primary"
          sx={{
            mt: 2,
          }}
        >
          Aceptar
        </Button>
      </DialogContent>
    </Dialog >
  );
};

export default FolioDialog;
